import React, { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  FormHelperText,
  IconButton,
  LinearProgress,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  styled,
  Typography,
} from "convertupleads-theme";
import {
  CloseIcon,
  UploadFileFilledIcon,
  UploadIcon,
} from "../../../common/Icons/Icons";

const FileSize = styled(Box)(({ theme }) => ({
  marginRight: 8,
  paddingRight: 8,
  position: "relative",
  "&:before": {
    content: '""',
    width: 3,
    height: 3,
    borderRadius: 2,
    position: "absolute",
    right: 0,
    top: "50%",
  },
}));
const CustomFileUpload = styled(Stack)(({ theme }) => ({
  textAlign: "center",
  padding: theme.spacing(3),
  border: `1.5px dashed ${theme.palette.other.outlinedBorder}`,
  borderRadius: 4,
  alignItems: "center",
  flex: 1,
  position: "relative",
  "& input": {
    opacity: 0,
    width: "100%",
    height: "100%",
    position: "absolute",
    cursor: "pointer",
  },
  "& .sgd_click_to_up": {
    color: theme.palette.primary.main,
    textDecoration: "none",
  },
}));

const FileUpload = ({
  maxSize = "SVG, PNG, JPG or GIF (max. 3MB)",
  variant = "circular",
  error = "",
}) => {
  const [files, setFiles] = useState([]);

  useEffect(() => {}, [files]);

  return (
    <Stack spacing={2} flex={1}>
      <CustomFileUpload>
        <input
          multiple
          type={"file"}
          onChange={(event) => {
            const selectedFiles = Array.from(event.target.files);
            setFiles(selectedFiles);
          }}
        />
        <UploadIcon color={"primary"} />
        <Typography variant={"body2"}>
          <span className={"sgd_click_to_up"}>Click to upload</span> or drag and drop
        </Typography>
        <FormHelperText sx={{ color: "text.tertiary", m: 0 }}>
          {maxSize}
        </FormHelperText>
      </CustomFileUpload>

      {files && files.length > 0 && (
        <List>
          {files.map((file, index) => (
            <ListItem
              key={index}
              secondaryAction={
                <Stack direction={"row"} spacing={1} alignItems={"center"}>
                  <IconButton
                    size={"small"}
                    edge="end"
                    onClick={() => setFiles([])}
                  >
                    <CloseIcon />
                  </IconButton>
                  {variant === "circular" && <CircularProgress size={24} />}
                </Stack>
              }
              sx={{ pr: 10 }}
            >
              <ListItemIcon>
                <UploadFileFilledIcon color={"primary"} />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography noWrap sx={{ display: "block", width: "100%" }}>
                    {file.name}
                  </Typography>
                }
                secondary={
                  <>
                    <Typography variant={"caption"}>
                      <FileSize
                        component={"span"}
                        sx={{
                          "&:before": {
                            bgcolor: error ? "error.main" : "text.secondary",
                          },
                        }}
                      >
                        {Math.ceil(file.size / 1024)} KB
                      </FileSize>
                      Completed
                    </Typography>
                    {variant === "linear" && <LinearProgress />}
                  </>
                }
                sx={{ flex: "unset" }}
              />
            </ListItem>
          ))}

          <ListItem
            secondaryAction={
              <Stack direction={"row"} spacing={1} alignItems={"center"}>
                <IconButton
                  size={"small"}
                  edge="end"
                  onClick={() => setFiles([])}
                >
                  <CloseIcon />
                </IconButton>
              </Stack>
            }
            sx={{ pr: 10 }}
          >
            <ListItemIcon>
              <UploadFileFilledIcon color={error ? "error" : "primary"} />
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography
                  color={error ? "error.main" : "text.secondary"}
                  noWrap
                  sx={{ display: "block", width: "100%" }}
                >
                  document_file_name.pdf
                </Typography>
              }
              secondary={
                <>
                  <Typography
                    color={error ? "error.main" : "text.secondary"}
                    variant={"caption"}
                  >
                    <FileSize
                      component={"span"}
                      sx={{
                        "&:before": {
                          bgcolor: error ? "error.main" : "text.secondary",
                        },
                      }}
                    >
                      {error}
                    </FileSize>
                    Failed
                  </Typography>
                  <LinearProgress />
                </>
              }
              sx={{ flex: "unset" }}
            />
          </ListItem>
        </List>
      )}
    </Stack>
  );
};

export default FileUpload;
